/**
 * Sets the market (and therefore the currency) from the language selector.
 *
 * Submits its own localization form instead of amending the theme's, so the
 * country_code field cannot be dropped by the theme's own submit handling.
 *
 * da -> DK market (DKK), de/en -> EU market (EUR).
 */

const COUNTRY_BY_LOCALE = {
  da: 'DK',
  de: 'DE',
  en: 'DE',
};

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest('button[name="locale_code"]');

    if (!button) {
      return;
    }

    const country = COUNTRY_BY_LOCALE[button.value];

    if (!country) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    // Strip the current market prefix so Shopify can re-apply the new one.
    const root = window.Shopify.routes.root;
    const path = window.location.pathname.replace(root, '/');

    const fields = {
      form_type: 'localization',
      utf8: '✓',
      _method: 'put',
      locale_code: button.value,
      country_code: country,
      return_to: path + window.location.search,
    };

    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${root}localization`;
    form.acceptCharset = 'UTF-8';
    form.enctype = 'multipart/form-data';
    form.hidden = true;

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  },
  true
);